import router from "@/router";
import { useUserStore } from "@/store/userStore";
import { toast } from "vue3-toastify";
import { logout, validate } from "@/api/requests/auth";

export async function handleLogout() {
  try {
    sessionExpiration.remove()
    await logout()
    const { resetUserInfo } = useUserStore()
    resetUserInfo()
    router.push("/login")
    toast.success("Logout efetuado com sucesso")
  }
  catch (e) {
    const { resetUserInfo } = useUserStore()
    resetUserInfo()
    router.push("/login")
    toast.error(e.message)
  }
}

export async function handleSoftLogout() {
  try{
  sessionExpiration.remove()
  softLogout()
  const { resetUserInfo } = useUserStore()
  resetUserInfo()
  router.push("/login")
  }
  catch(e){
    toast.error(e.message)
  }
}

export async function softLogout() { // Removes frontend cookies
  cookieStore.delete("csrftoken")
  cookieStore.delete("access")
  cookieStore.delete("refresh")
}


export function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export async function isAuth() {
  try {
    await validate()
    return true
  }
  catch (e) {
    return false
  }
}

export const sessionExpiration = {
  KEY: "session_expiration",

  isExpired(): boolean {
    const expirationDate = localStorage.getItem(this.KEY);
    if (!expirationDate) return false; // If no expiration date, session is not expired (user could be in login page)
    return new Date(expirationDate) < new Date();
  },
  set(expirationDate: string) {
    localStorage.setItem(this.KEY, expirationDate);
  },
  get(): string | null {
    return localStorage.getItem(this.KEY);
  },
  remove() {
    localStorage.removeItem(this.KEY);
  },
};
